import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Pencil, Trash2, Eye, EyeOff, Copy } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import AdminLayout from "./AdminLayout";

export default function AdminTours() {
  const [tours, setTours] = useState(null);
  const [tab, setTab] = useState("all");
  const nav = useNavigate();

  const load = () => api.get("/admin/tours").then((r) => setTours(r.data)).catch(() => setTours([]));
  useEffect(() => { load(); }, []);

  const togglePublish = async (t) => { await api.patch(`/admin/tours/${t.id}/publish`); load(); };
  const del = async (id) => { if (!window.confirm("Delete this tour?")) return; await api.delete(`/admin/tours/${id}`); toast.success("Deleted"); load(); };
  const clone = async (t) => { try { const { data } = await api.post(`/admin/tours/${t.id}/clone`); toast.success("Package cloned as draft"); nav(`/admin/tours/edit/${data.id}`); } catch { toast.error("Clone failed"); } };

  const counts = tours ? { all: tours.length, India: tours.filter((t) => t.region === "India").length, International: tours.filter((t) => t.region !== "India").length } : { all: 0, India: 0, International: 0 };
  const filtered = tours ? (tab === "all" ? tours : tours.filter((t) => (tab === "India" ? t.region === "India" : t.region !== "India"))) : [];

  return (
    <AdminLayout title="Tours">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap gap-2">
          {[["all", "All"], ["India", "India"], ["International", "International"]].map(([key, lbl]) => (
            <button key={key} onClick={() => setTab(key)} data-testid={`tours-tab-${key}`} className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${tab === key ? "brand-gradient text-white" : "border border-gray-200 text-navy hover:border-brandorange"}`}>{lbl} ({counts[key]})</button>
          ))}
        </div>
        <button onClick={() => nav("/admin/tours/new")} data-testid="add-tour-btn" className="btn-gradient flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold"><Plus className="h-4 w-4" /> New Tour</button>
      </div>
      {tours === null ? <div className="space-y-3">{Array.from({ length: 3 }).map((_, i) => <div key={i} className="h-16 skeleton rounded-2xl" />)}</div> : (
        <div className="overflow-x-auto rounded-2xl border border-gray-100 bg-white card-soft">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left text-xs uppercase text-gray-400"><tr><th className="p-4">Tour</th><th className="p-4">Region</th><th className="p-4">Type</th><th className="p-4">Price</th><th className="p-4">Status</th><th className="p-4 text-right">Actions</th></tr></thead>
            <tbody>
              {filtered.map((t) => (
                <tr key={t.id} data-testid={`tour-row-${t.slug}`} className="border-t border-gray-50">
                  <td className="p-4"><div className="flex items-center gap-3"><img src={t.hero_image} alt="" className="h-10 w-14 rounded-lg object-cover" /><div><p className="font-semibold text-navy">{t.title}</p><p className="text-xs text-gray-400">{t.destination}</p></div></div></td>
                  <td className="p-4">{t.region}</td>
                  <td className="p-4">{t.package_type}</td>
                  <td className="p-4 font-semibold">₹{Number(t.price).toLocaleString("en-IN")}</td>
                  <td className="p-4"><span className={`rounded-full px-2.5 py-1 text-xs font-bold ${t.published ? "bg-emerald-100 text-emerald-700" : "bg-gray-100 text-gray-500"}`}>{t.published ? "Published" : "Draft"}</span></td>
                  <td className="p-4"><div className="flex justify-end gap-2">
                    <button onClick={() => togglePublish(t)} data-testid={`publish-${t.slug}`} className="rounded-lg p-2 text-gray-500 hover:bg-gray-100">{t.published ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}</button>
                    <button onClick={() => clone(t)} title="Clone package" data-testid={`clone-${t.slug}`} className="rounded-lg p-2 text-navy hover:bg-navy/5"><Copy className="h-4 w-4" /></button>
                    <button onClick={() => nav(`/admin/tours/edit/${t.id}`)} data-testid={`edit-${t.slug}`} className="rounded-lg p-2 text-blue-600 hover:bg-blue-50"><Pencil className="h-4 w-4" /></button>
                    <button onClick={() => del(t.id)} data-testid={`delete-${t.slug}`} className="rounded-lg p-2 text-brandred hover:bg-red-50"><Trash2 className="h-4 w-4" /></button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}
